import React, { useMemo } from 'react';
import './style.scss';
import { Image, Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import { FlippingCardPlusIcon } from '../icons';
import clsx from 'clsx';
import ReactPlayer from 'react-player';

const FlippingCardFront = ({
  handleFlip,
  heading,
  rendering,
  align = 'Middle',
  background = null,
  headerSize = 'H1',
  className,
  iconClassName,
  componentWidth,
  showBack,
}) => {
  const contentClassName = useMemo(() => {
    return clsx('fc-card-front-content', `fc-card-front-content-${align}`);
  }, [align]);

  return (
    <div className={clsx(className, 'fc-card-front')} onClick={handleFlip}>
      <Background background={background} />
      <div className={contentClassName}>
        <h2 className={clsx('fc-card-heading', `fc-card-heading-${headerSize}`)}>
          <Text field={heading} />
        </h2>
        <div className="fc-card-placeholders">
          <Placeholder name="jss-fp-front" rendering={rendering} sub={true} />
          {componentWidth === '1120' && (
            <Placeholder name="jss-fp-front-right" rendering={rendering} />
          )}
        </div>
      </div>
      {showBack && <FlippingCardPlusIcon className={iconClassName} />}
    </div>
  );
};

const Background = ({ background }) => {
  if (background.video?.value?.src) {
    const { src } = background.video.value;
    return (
      <div className="fc-card-front-bg">
        <ReactPlayer
          width="unset"
          height="unset"
          className="fc-card-front-bg-video"
          url={src}
          loop={true}
          controls={false}
          volume={0}
          muted={true}
          playing={true}
          playsinline={true}
        />
      </div>
    );
  }

  if (background.image?.value?.src) {
    return (
      <div className="fc-card-front-bg">
        <Image field={background.image} className="fc-card-front-bg-image" />
      </div>
    );
  }

  if (background.color?.value) {
    return <div className="fc-card-front-bg" style={{ background: background.color.value }} />;
  }

  return (
    <div className="fc-card-front-bg">
      <div className="fc-card-front-bg-default" />
    </div>
  );
};

export default FlippingCardFront;
